import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import Apply from "./Apply";
import Sort from "./Sort";

const GenericFilter = ({
  setSort,
  sort,
  setSortAsc,
  sorts,
  setAdvancedFilter,
  handlesubmit,
  resetForm,
  advancedFilter,
}) => {
  //   const dispatch = useDispatch();
  //   const { formatMessage } = useIntl();
  //   const [advancedFilter, setAdvancedFilter] = useState(false);

  return (
    <>
      <Sort
        setSort={setSort}
        sort={sort}
        sorts={sorts}
        setSortAsc={setSortAsc}
      />
      <Apply
        advancedFilter={advancedFilter}
        resetForm={resetForm}
        handleSubmit={handlesubmit}
        setAdvancedFilter={setAdvancedFilter}
      />
    </>
  );
};

export default GenericFilter;
